import travelerImage from "../assets/image/icons8-traveler-100.svg";
import visaImage from "../assets/image/3057653_media_payment_social_visa_icon-svg.svg";
import airportImage from "../assets/image/airport_100px.svg";
import hotelImage from "../assets/image/hotel_100px.svg";
import theImage from "../assets/image/20211007_120240.png";

export default function Men(props) {
  const theList = [
    {
      text: "تور انفرادی",
      image: travelerImage,
    },
    {
      text: "ویزا",
      image: visaImage,
    },
    {
      text: "بلیط هواپیما",
      image: airportImage,
    },
    {
      text: "رزرو هتل",
      image: hotelImage,
    },
  ];

  return (
    <div className="container">
      <div className="mt-4 fw-bolder fs-4 text-color">خدمات</div>
      <div className="row">
        <div className="d-flex flex-wrap col-lg-7 col-md-12 justify-content-around">
          {theList.map((value, index) => (
            <div className="col-12 col-md-6" key={index}>
              <div className="d-flex border border-secondary round m-2 align-items-center service-padding">
                <img
                  className="mx-4"
                  src={value.image}
                  style={{ width: "50px", height: "auto" }}
                  alt=""
                />
                <div className="me-4">
                  <div className="text-color mt-3">{value.text}</div>
                  <div className="size3 text-secondary font-regular">توضیحات</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className=" col-lg-5 col-md-12 ">
          <img
            className="round w-100"
            src={theImage}
            style={{ maxHeight: "200px" }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
